module.exports = __webpack_public_path__ + "img/gold.b47f89bf.png";